export default __webpack_public_path__ + "static/screenshot-c8b5c5ee1936b957017d83a86e06f2ca.png";